export default (element) => {
    return element.classList.contains("text-neutral-400");
}
